
// Basic XORCipher for the FF ñapa
const XORCipher = require('./XORCipher').XORCipher;

(function(){

    function encode(user, pass){

        const user_pass = user + '||' + pass;
        const encoded = XORCipher.encode('ffñapa', user_pass);
        return encoded.match(/.{1,6}/g);

    }

    function decode(list){

        const encoded = list.join('');
        const decoded = XORCipher.decode('ffñapa', encoded);
        const user_pass = decoded.split('||',2);

        return {
            user: user_pass[0],
            pass: user_pass[1],
        }

    }

    window.FFSaveLogin = {
        encode,
        decode,
    };

}());

